<template>
  <div ref="notifications" class="profile-notifications">
    <div class="profile-notifications-header">
      <div class="title">
        {{ $t("notifications.title") }}
      </div>
      <slot name="btn-back" />

      <!--      <Button-->
<!--        class="clear-button"-->
<!--        type="green"-->
<!--        :value="$t('notifications.btn_clear_all')"-->
<!--        :height="26"-->
<!--        :width="80"-->
<!--        position="right"-->
<!--        @click="openDialog"-->
<!--      />-->

      <Dialog :visible.sync="showDialog" :modal="true">
        <template #header>
          <div class="dialog-title">
            {{ $t('notifications.dialog.title') }}
          </div>
          <div class="close-icon" @click="rejectConfirmation" />
        </template>

        <div class="dialog-image">
          <img src="@/assets/images/icons/icon_warning.svg" alt="#">
        </div>
        <div class="dialog-text">
          {{ $t('notifications.dialog.text') }}
        </div>

        <template #footer>
          <Button
            class=""
            type="transparent"
            :value="$t('notifications.dialog.btn_cancel')"
            :height="50"
            :width="122"
            position="right"
            @click="rejectConfirmation"
          />
          <Button
            class=""
            type="green"
            :value="$t('notifications.dialog.btn_delete')"
            :height="50"
            :width="80"
            position="right"
            @click="clearAllNotifications"
          />
        </template>
      </Dialog>
    </div>
    <div class="profile-notifications-body">
      <div class="notifications-wrapper">
        <Loader v-if="loading" />
        <template v-else-if="hasNotifications">
          <notification-content v-for="(notification, index) of notificationsData.notifications"
                                :key="index"
                                :notification="notification"
                                class="notification"
          />
        </template>
        <div v-else class="notifications-empty description">
          {{ $t('notifications.no_notifications') }}
        </div>
      </div>
    </div>
    <div v-if="hasNotifications" class="profile-notifications-footer">
      <div class="loader-more-notifications">
        <Loader v-if="isLoadMore" />
      </div>
      <div class="description">
        {{ $t('notifications.notice_description') }}
      </div>
    </div>
    <Toast />
  </div>
</template>

<script>
import { ProfileService } from "@/profiles/services/profiles";
import Loader from "@/components/Loader";
import Dialog from 'primevue/dialog';
import NotificationContent from "../../components/NotificationContent";

export default {
  name: "Notifications",

  components: {
    NotificationContent,
    Dialog,
    Loader
  },

  data() {
    return {
      notificationsData: {},
      showDialog: false,

      scrollReady: true,
      loading: true,
      isLoadMore: false
    }
  },

  computed: {
    offsetNotifications() {
      return this.notificationsData.notifications ? this.notificationsData.notifications.length : 0
    },
    hasNotifications() {
      return this.notificationsData.notifications && this.notificationsData.notifications.length > 0
    }
  },

  watch: {
    notificationsData: {
      handler: function() {
        this.loading = false
      },
      deep: true
    }
  },

  mounted() {
    this.initData()
  },

  destroyed() {
    window.onscroll = () => {}
  },

  methods: {
    async initData() {
      this.downloadMore()
      await this.getNotificationsData( )
    },

    async getNotificationsData(reload = false) {
      reload *= 1;
      this.notificationsData = await ProfileService.getNotifications({ offset: 0, reload })
    },

    downloadMore() {
      window.onscroll = async () => {
        let scrollHeight = (Math.ceil(window.pageYOffset) || document.documentElement.scrollTop || document.body.scrollTop) + window.innerHeight;
        let containerBottom = Math.ceil(this.$refs.notifications.getBoundingClientRect().bottom + window.pageYOffset);

        if (scrollHeight >= containerBottom && this.notificationsData.has_more && this.scrollReady) {
          this.isLoadMore = true
          this.scrollReady = false
          await this.addNewNotifications()
        }
      }
    },

    async addNewNotifications() {
      let newNotifications = await ProfileService.getNotifications({ offset: this.offsetNotifications })
      this.notificationsData.has_more = newNotifications.has_more
      this.notificationsData.unread_notifications_count = newNotifications.unread_notifications_count
      this.notificationsData.notifications.push(...newNotifications.notifications)
      this.scrollReady = true
      this.isLoadMore = false
    },

    openDialog() {
      this.showDialog = true
    },

    rejectConfirmation() {
      this.showDialog = false
    },

    clearAllNotifications() {
      this.showDialog = false
      ProfileService.clearNotifications(
        {},
        (res) => {
          if (res) {
            this.initData()
          }
        }
      )
    },
  }
}
</script>

<style lang="scss">
.profile-notifications {
  min-height: 600px;
  position: relative;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #E9E9E9;
  border-radius: 4px;

  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px 40px 10px;

    .title {
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      color: #808080;
      width: 100%;
      position: absolute;
      left: 0;
      text-align: center;
    }
    .clear-button {
      font-size: 12px !important;
    }
  }

  &-body {
    flex: 1 1 auto;
    padding: 10px 0;

    .notifications-wrapper {
      height: 100%;
    }
  }

  &-footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 25px 40px 50px;
    .download-button {
      max-width: 122px;
      margin-bottom: 10px;
      font-weight: 400;
      font-size: 12px !important;
      line-height: 16px !important;
    }
    .loader-more-notifications {
      margin-bottom: 20px;
      .loader img {
        position: static;
      }
    }
  }
  .description {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #808080;
  }
  .notifications-empty {
    text-align: center;
    padding: 150px 0;
  }
}
</style>
